import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiDataService } from '../../services/api.service';
import { ShService } from '../../services/sh-service';
import { ToastrService } from 'ngx-toastr';
import { storageService } from '../storage.service';

@Component({
    selector: 'app-login',
    imports: [FormsModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  userEmail: string = '';
  userPass: string = '';
  invalidLogin: boolean = false;
  loader: boolean = false;

  constructor(
    private router: Router,
    private _apiService: ApiDataService,
    private _service: ShService,
    private toastr: ToastrService,
    private _storage: storageService
  ) { }

  ngOnInit(): void {
    this._service.isLoggedIn$.next(false);
  }

  forgot() {
    this.router.navigate(["/forgot-password"]);
  }

  login() {
    this.loader = true;
    const PAYLOAD = {
      userName: this.userEmail, //"psingh",
      password: this.userPass //"12312"
    };
    this._apiService.login(PAYLOAD).subscribe(x => {
      if (x.status === 'Invalid credentials' || x.status === 'Inactive user') {
        this.loader = false;
        this.toastr.error(`${x.status}`, 'Error', {
          timeOut: 3000,
        });
        this.invalidLogin = true;
        setTimeout(() => {
          this.invalidLogin = false;
        }, 2000);
      }
      else {
        if (x.firstTimeLogin) {
          this.router.navigateByUrl(`/change-password?transactionId=${this.userEmail}`);
          return;
        }
        else {
          const lobs = x.lobs || [];
          sessionStorage.setItem('lobs', JSON.stringify(lobs));
          this._storage.setStorage(x);
          
          // if (lobs.length > 1) {
          //   this.router.navigate(["/select-lob"],{state:{loginData:x}}); // Route to LOB selector screen
          // } else {
          //   this._storage.setStorage(x);
          // }
        }
      }
    }, (error) => {
      alert(error.error.error);
      this.loader = false;
    }, () => {
      this.loader = false;
    });
  }

  // getLabels() {
  //   this._apiService.getLabels().subscribe(x => {
  //     sessionStorage.setItem('labels', JSON.stringify(x[0]));

  //     this._service.isLoggedIn$.next(true);
  //     this._service.isLabelLoaded$.next(true);
  //   });
  // }
}
